import { AtonTargetInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';
import { useLengthUnits } from '../../Units/useLengthUnits';
import {
  InfoTooltipFields,
  type TooltipFieldDefinition,
} from './InfoTooltipFields';

interface AtonInfoTooltipProps {
  atonInfo: AtonTargetInfo;
}

export const AtonInfoTooltip = ({ atonInfo }: AtonInfoTooltipProps) => {
  const { settings } = useSettings();
  const ribbonSettings = settings['ribbonPlugin.settings'];
  const { convertLengthString } = useLengthUnits();

  const fields: TooltipFieldDefinition[] = [
    {
      key: 'assignedMode',
      label: 'Assigned mode',
      value: atonInfo.assignedMode,
      visible: ribbonSettings?.show_aton_assigned_mode,
    },
    {
      key: 'atonType',
      label: 'AtoN Type',
      value: atonInfo.atonType,
      visible: ribbonSettings?.show_aton_type,
    },
    {
      key: 'targetType',
      label: 'Target type',
      value: atonInfo.targetType,
      visible: ribbonSettings?.show_target_type,
    },
    {
      key: 'country',
      label: 'Country',
      value: atonInfo.country,
      visible: ribbonSettings?.show_aton_country,
    },
    {
      key: 'latitude',
      label: 'Latitude',
      value: atonInfo.latitude,
      visible: ribbonSettings?.show_aton_latitude,
    },
    {
      key: 'longitude',
      label: 'Longitude',
      value: atonInfo.longitude,
      visible: ribbonSettings?.show_aton_longitude,
    },
    {
      key: 'length',
      label: 'Length',
      value: atonInfo.length ? convertLengthString(atonInfo.length) : undefined,
      visible: ribbonSettings?.show_aton_length,
    },
    {
      key: 'mmsi',
      label: 'MMSI',
      value: atonInfo.mmsi,
      visible: ribbonSettings?.show_aton_mmsi,
    },
    {
      key: 'name',
      label: 'Name',
      value: atonInfo.name,
      visible: ribbonSettings?.show_aton_name,
    },
    {
      key: 'offPosition',
      label: 'Off position',
      value: atonInfo.offPosition,
      visible: ribbonSettings?.show_aton_off_position,
    },
    {
      key: 'state',
      label: 'State',
      value: atonInfo.state,
      visible: ribbonSettings?.show_aton_state,
    },
    {
      key: 'status',
      label: 'Status',
      value: atonInfo.status,
      visible: ribbonSettings?.show_aton_status,
    },
    {
      key: 'width',
      label: 'Width',
      value: atonInfo.width ? convertLengthString(atonInfo.width) : undefined,
      visible: ribbonSettings?.show_aton_width,
    },
  ];

  return <InfoTooltipFields fields={fields} />;
};
